/** A retainer's invoice schedule, the same arithmetic as money.py of portal-bff. */
import type { Covers } from '@/api/types';

export type { Covers };

export const coversLabel: Record<Covers, string> = {
  next: 'за следующий месяц (предоплата)',
  current: 'за текущий месяц',
  previous: 'за прошедший месяц',
};

const OFFSET: Record<Covers, number> = { next: 1, current: 0, previous: -1 };
const MONTHS = ['январь', 'февраль', 'март', 'апрель', 'май', 'июнь', 'июль', 'август', 'сентябрь', 'октябрь', 'ноябрь', 'декабрь'];

export function shiftPeriod(period: string, months: number): string {
  const n = Number(period.slice(0, 4)) * 12 + Number(period.slice(5, 7)) - 1 + months;
  return `${Math.floor(n / 12)}-${String((n % 12) + 1).padStart(2, '0')}`;
}

export const periodLabel = (period: string) => `${MONTHS[Number(period.slice(5, 7)) - 1]} ${period.slice(0, 4)}`;

/** The day the invoice for `period` goes out: the billing day of its month, or the last day of a shorter one. */
export function invoiceDate(period: string, covers: Covers, day: number): string {
  const ym = shiftPeriod(period, -OFFSET[covers]);
  const [y, m] = [Number(ym.slice(0, 4)), Number(ym.slice(5, 7))];
  const last = new Date(Date.UTC(y, m, 0)).getUTCDate();
  return `${ym}-${String(Math.min(day, last)).padStart(2, '0')}`;
}

export type BillingTerms = { nextInvoiceAt: string; billingDay?: number; billingCovers?: Covers; nextPeriod?: string; lastInvoicedPeriod?: string };

/** The month the next invoice is for. Older terms have only the date: their period is its month. */
export function nextPeriodOf(t: BillingTerms): string {
  return t.nextPeriod ?? shiftPeriod(t.nextInvoiceAt.slice(0, 7), OFFSET[t.billingCovers ?? 'current']);
}
